import React from "react";
import { TimelineContainer, TimelineItem } from "./style";
import { Container, Row } from "react-bootstrap";
import ProgressBar from "~/components/HeaderSlim/ProgressBar";

type TimeLineProps = {
    steps: Array<string>;
    currentStep: number;
};

const Timeline = ({ steps, currentStep }: TimeLineProps) => {
    return (
        <Container>
            <TimelineContainer>
                {steps.map((step, index) => (
                    <TimelineItem key={index} active={index === currentStep - 1}>
                        <div className="dot">{index + 1}</div>
                        <span>{step}</span>
                    </TimelineItem>
                ))}
            </TimelineContainer>
            <ProgressBar currentStep={currentStep} totalSteps={steps.length} />
        </Container>
    );
};

export default Timeline;
